import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { InfoTip } from "@/components/InfoTip";

const toneCls = {
  good: "text-emerald-600",
  warn: "text-amber-600",
  bad: "text-red-600",
  neutral: "text-foreground",
};

export const MiniStat = ({ label, value, tone = "neutral", info }) => (
  <div className="flex flex-col gap-1.5 px-4 py-4 transition-colors hover:bg-secondary/50">
    <span className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.1em] text-muted-foreground">
      {label}
      {info ? <InfoTip text={info} /> : null}
    </span>
    <span className={cn("font-mono text-xl font-semibold leading-none", toneCls[tone])}>{value}</span>
  </div>
);

export const SummaryPanel = ({ title, icon: Icon, to, stats, cols = "grid-cols-2 sm:grid-cols-5", testId, className }) => (
  <div
    data-testid={testId}
    className={cn("overflow-hidden rounded-xl border border-border bg-card card-elevated transition-shadow duration-300 hover:shadow-lg", className)}
  >
    <div className="flex items-center justify-between border-b border-border/70 px-5 py-4">
      <div className="flex items-center gap-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary text-foreground">
          <Icon className="h-4 w-4" strokeWidth={2} />
        </div>
        <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
      </div>
      {to ? (
        <Link
          to={to}
          data-testid={testId ? `${testId}-link` : undefined}
          className="inline-flex items-center gap-1 text-xs font-semibold text-brand transition-colors hover:text-brand/80"
        >
          Details <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      ) : null}
    </div>
    <div className={cn("grid gap-px bg-border/60", cols)}>
      {stats.map((s, i) => (
        <div key={i} className="bg-card">
          <MiniStat {...s} />
        </div>
      ))}
    </div>
  </div>
);
